<template>
<div class="">
        <div class="page-top mb-1 mb-3 clearfix">
			<ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
				<li class="nav-item">
                    <router-link to="/vendors" id="complete-profile-tab" data-toggle="tab" class="nav-link" role="tab" aria-controls="complete-profile" aria-selected="true"> Complete Profile ({{ completeCount }})</router-link>
				</li>
				<li class="nav-item">
                    <router-link to="/incompleteVendors" id="incomplete-profile-tab" data-toggle="tab" class="nav-link active" role="tab" aria-controls="incomplete-profile" aria-selected="true"> Incomplete Profile ({{ incompleteCount }})</router-link>
				</li>
			</ul>
            <router-link to="/addVendorBasicDetail" class="btn btn-primary float-right"> Add Vendor</router-link>
			<a href="#" class="btn btn-primary float-right mr-1"> Vendor Bulk Upload </a>
		</div>
        <div class="row normal-ib-space mb-3">
			<div class="col-md-4">
				<select class="selectpicker custom-select2" data-live-search="true" name="">
					<option value="">City</option>
					<option value="">1</option>
					<option value="">2</option>
					<option value="">3</option>
				</select>
			</div>
			<div class="col-md-4">
				<select class="selectpicker custom-select2" name="">
					<option value="">Status</option>
					<option value="">1</option>
					<option value="">2</option>
					<option value="">3</option>
				</select>
			</div>
			<div class="col-md-4">
				<input id="search" type="text" class="form-control" placeholder="Name/SimSim or Mobile number" name="" />
			</div>
		</div>
        <div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="complete-profile" role="tabpanel" aria-labelledby="complete-profile-tab">
				<div class="table-holder">
                    <table id="vendorTable" class="table table-responsive-xl" style="width:100%">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Account Type</th>
                                <th>Account</th>
                                <th>Category</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                    </table>
				</div>
			</div>
		</div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                completeCount:null,
                incompleteCount:null,
                data : null
            };
        },
        mounted() {
            this.$Progress.start();
            this.getVendorCount();
            $('#vendorTable').DataTable({
                processing: true,
                serverSide: true,
                "searching":false,
                "aaSearching": false,
                "autoWidth": false,
                "bLengthChange":false,
                ajax: {
                    "url": "api/incompleteVendors",
                    "headers": window.axios.defaults.headers.common,
                    "dataSrc": "records",
                },
                deferRender: true,
                columns: [
                    {data: 'id', visible: false},
                    {data: 'name'},
                    {data: 'mobile_no'},
                    {data: 'account_type',render: function(data,type,full){
                        if(full['default_beneficiary'] != null){
                                var accountType =  full['default_beneficiary'].account_type;
                                if(accountType == 'SIMSIM'){
                                    return 'SimSim';
                                }else{
                                    return full['default_beneficiary'].bank.name;
                                }
                            }else if(full['beneficiaries'].length > 0){
                                var accountType =  full['beneficiaries'][0].account_type;
                                if(accountType == 'SIMSIM'){
                                    return 'SimSim';
                                }else{
                                    return full['beneficiaries'][0].bank.name;
                                }
                            }else{
                                return 'Not found';
                            }
                    }},
                    {data: 'account_number', render: function(data,type,full){

                         if(full['default_beneficiary'] != null){

                                return full['default_beneficiary'].account_number;

                            }else if(full['beneficiaries'].length > 0){

                                return full['beneficiaries'][0].account_number;

                            }else{
                                return 'Not found';
                            }
                    }},
                    {data: 'category_name'},
                    {data: 'id', sorting: false, render: function(data,type,full){
                        var $url = '/editVendor/'+full['id'];
                        return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" >Edit</a>';
                    }}
                ],
                "order": [[ 0, "desc" ]],
                "initComplete": () => {
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            getVendorCount() {
                axios.get('/api/VendorCount')
                .then(res => {
                    if(res.status == 200){

                            this.completeCount = res.data.complete;
                            this.incompleteCount = res.data.incomplete;

                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load permissions'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load Vendor count'
                    });
                });
            }
        },
        created() {
            //
        }
    }
</script>
